// extracted by mini-css-extract-plugin
module.exports = {"workspaceView":"WorkspaceView_workspaceView__1rfK6","header":"WorkspaceView_header__3WOtF","sticky":"WorkspaceView_sticky__373g9"};